export default __webpack_public_path__ + "static/media/instagram-square-brands.2452ef64.svg";